import { style } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";
import { rem } from "@huub-web/utils/css/rem";

import { activeState } from "../../../theme/activeState";
import { transition } from "../../../utils";

import { theme } from "../../../theme/css/theme.css";

export const containerStyle = recipe({
  base: {
    zIndex: 3,
    color: theme.colors.background,
    height: "100%",
    width: "25%",
    display: "flex",
    alignItems: "center",
    padding: theme.spacings.s,
    cursor: "pointer",
    position: "relative",
    selectors: {
      "&:before": {
        content: '""',
        position: "absolute",
        top: rem(-2),
        height: `calc(100% + ${rem(2)})`,
        width: "100%",
        left: 0,
        transition: transition("opacity"),
        opacity: 0.1,
      },
      "&:active": {
        ...activeState,
      },
    },
  },
  variants: {
    variant: {
      left: {
        justifyContent: "flex-start",
        selectors: {
          "&:before": {
            background: "linear-gradient(to left, transparent, rgb(0, 0, 0))",
          },
          "&:hover:before": {
            opacity: 0.3,
          },
        },
      },
      right: {
        justifyContent: "flex-end",
        selectors: {
          "&:before": {
            background: "linear-gradient(to right, transparent, rgb(0, 0, 0))",
          },
          "&:hover:before": {
            opacity: 0.3,
          },
        },
      },
    },
  },
});

export const iconButtonStyle = style({
  zIndex: 3,
  pointerEvents: "none",
});
